import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import serverEndPoint from './../dxdm';

// import serverConfig from './../dxdm';
import './SiteIdentity.css'
const headerSyle = {
    paddingTop: "15pt",
    backgroundColor: "white"
}

export class SiteIdentity extends Component {
    render() {
        return (
            <div style={headerSyle}>
                <div className="container" style={{ display: "flex", position: "relative", alignItems: "center" }}>
                    <div className="row" style={{ width: "100%" }}>
                        <h3 className="col-sm-4 leftLogo" >
                            <Link to={`/`}><img alt="Data Insight Lab FAST" width="150" src={`${serverEndPoint}/images/Datainsightlablogo.png`} /></Link>
                            {/* <Link to={`${serverConfig}/`}><img alt="Data Insight Lab FAST" width="150" src='images/Datainsightlablogo.png' /></Link> */}
                        </h3>
                        <h3 className="col-sm-4 centerLogo" > <div style={{ textDecoration: "none", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}></div> </h3>
                        <h3 className="col-sm-4 rightLogo"> <img width="110" alt="FAST National University" src={`${serverEndPoint}/images/UniLogo.png`} /></h3>
                    </div>
                </div>
            </div>
        )
    }
}

export default SiteIdentity
